import { Input, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';
import { EMAIL, MAX_SUBJECT_LENGTH } from '@hero/constants';
import { formatNumber } from '@hero/utils';

const SubjectLineWrapper = styled.div`
  height: 100%;
  position: relative;
  width: 100%;

  @media (max-width: 921px) {
    width: 100%;
  }
`;

function SubjectLine({ subject, setSubject }) {
  const { errors } = useValidationErrorsStore();
  const { t } = useTranslation();

  return (
    <SubjectLineWrapper id={EMAIL}>
      <Typography variant="body1Bold" style={{ marginBottom: 16 }}>
        {t('chooseAnEmailSubjectLine')}:
      </Typography>
      <Input
        name="subject"
        variant="outlined"
        value={subject}
        onChange={e => setSubject(e.target.value)}
        inputProps={{
          maxLength: MAX_SUBJECT_LENGTH,
          validations: {
            required: {
              required: true,
              message: t('inputEmptyWarning', { name: t('subjectLine') })
            }
          }
        }}
        error={errors?.warning?.find(e => e.key === 'getSubjectLineRule')}
        helperText={
          <Typography variant="caption1" emphasis="weaker" color="inherit">
            {t('lengthCharacters', {
              length: formatNumber(subject?.length),
              limit: MAX_SUBJECT_LENGTH
            })}
          </Typography>
        }
      />
    </SubjectLineWrapper>
  );
}

export { SubjectLine };
